import { useTranslation } from "react-i18next";
/**
 * Full-page loading fallback shown while a lazily-imported route chunk loads.
 * Mirrors the app's visual language (rounded, soft card, brand accent) and is
 * announced to screen readers via role="status".
 */
export default function PageLoader({ label }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label || t("interface.loadingLabel")}
      className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-4"
    >
      <div
        aria-hidden="true"
        className="h-9 w-9 rounded-full border-2 border-primary/20 border-t-primary animate-spin"
      />
      {label ? (
        <span className="text-sm font-medium text-muted-foreground">{label}</span>
      ) : (
        <span className="sr-only">{t("interface.loading")} </span>
      )}
    </div>
  );
}
